<div id="body">
  @if (isAuthenticated) {
  <div id="header">
    <div class="body-cell">
      <div class="content-1920">
        <div class="content-padding">
          <div class="header-buttons-left">
            <img src="images/harvest_mate_logo_colour.png" width="300" />
          </div>
          <div class="header-buttons">
            <div class="header-menu">
              <a class="btn__header btn-home" routerLink="/" title="Home"></a>
              @if (isContrator) {
              <a
                class="btn__header btn-machinery"
                routerLink="/harvesters"
                title="Machinery & Labour Setup"
              ></a>
              } @if (isContrator) {
              <a
                class="btn__header btn-annual"
                routerLink="/contractor-groups"
                title="Group & Operational Setup"
              ></a>
              } @if (isContrator) {
              <a
                class="btn__header btn-infield"
                href="/farms"
                title="Infield Logistics"
              ></a>
              } @if (isGrower) {
              <a
                class="btn__header btn-infield"
                href="/farms"
                title="Infield Logistics"
              ></a>
              } @if (isGrower) {
              <a
                class="btn__header btn-annual"
                routerLink="/grower-groups"
                title="Group & Operational Setup"
              ></a>
              } @if (isGrower) {
              <a
                class="btn__header btn-contract"
                routerLink="/contract-negotiation"
                title="Comparison Scenarios"
              ></a>
              }
              <a
                class="btn__header btn-info"
                routerLink="/about"
                title="About"
              ></a>
            </div>
            <button class="btn__header btn-menu"></button>
            <a
              class="profile__icon modal-profile"
              role="button"
              tabindex="0"
              title="{{ fullName }}"
              >{{ shortName }}</a
            >
          </div>
          <div class="profile__menu">
            <a class="profile__header">
              <span class="profile__icon">{{ shortName }}</span>
              <span class="profile__name"
                >{{ user.givenName }} {{ user.lastName }}</span
              >
              <span class="profile__view">View Profile</span>
            </a>
            <a routerLink="/forgotPassword">Reset Password</a>
            <!-- <a *ngIf="isContrator" routerLink="/fixed-cost">Fixed Cost Calculator</a> -->
            @if (isContrator) {
            <a routerLink="/harvesters">My Harvesters</a>
            } @if (isGrower) {
            <a routerLink="/farms">Farm Management</a>
            } @if (isGrower) {
            <a routerLink="/group-invitations">Group Invitations</a>
            } @if (isAdmin) {
            <a routerLink="/admin/userManagement">User Management</a>
            } @if (isAdmin) {
            <a routerLink="/admin/harvesterManagement">Harvester Management</a>
            } @if (isAdmin) {
            <a routerLink="/admin/regionManagement">Region Management</a>
            } @if (isAdmin) {
            <a routerLink="/admin/cropManagement">Variety Management</a>
            } @if (isAdmin) {
            <a routerLink="/admin/seasonManagement">Season Management</a>
            } @if (isAdmin) {
            <a routerLink="/admin/repairMaintenance">Repair And Maintenance</a>
            }
            <a
              role="button"
              tabindex="0"
              (click)="signOut()"
              (keydown.enter)="signOut()"
              (keydown.space)="signOut(); $event.preventDefault()"
              >Logout</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  <div id="content">
    <router-outlet></router-outlet>
  </div>
  <div id="footer">
    <div class="body-cell">
      <div class="content-1920">
        <div class="content-padding">
          <p class="copyright">
            &copy; 2026 Copyright 2026 by Sugar Research Australia Ltd. &ensp;
            <br />
            &ensp; This tool was developed by
            <strong>Sugar Research Australia</strong> and the
            <strong>Department of Agriculture & Fisheries.</strong>
            <br />
            <br />
            <strong>All rights reserved.</strong> No part of Harvest Mate may be
            reproduced, stored in a retrieval system, or transmitted <br />in
            any form or by any means, electronic, mechanical, photocopying,
            recording, or otherwise, without the prior <br />
            permission of Sugar Research Australia Ltd.
          </p>
          <div class="header-buttons">
            <a class="image_footer" href="https://www.qld.gov.au/"
              ><img src="images/queensland_government_white.png" width="170"
            /></a>
            <img class="image_footer" src="images/logo-sra.svg" width="170" />
          </div>
        </div>
      </div>
      <div style="padding: 10px 10px">
        <a href="assets/HarvestMateTM Terms of Use.docx" style="padding: 10px"
          >Terms of Use</a
        >
        <a
          href="https://sugarresearch.com.au/about/policies/privacy-policy-3/"
          target="_blank"
          rel="noopener noreferrer"
          style="padding: 10px"
          >Privacy Policy</a
        >
      </div>
    </div>
  </div>
</div>
